import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, map, catchError, of } from 'rxjs';
import { environment } from 'src/environments/environment';
import { IPayOption, PlansList } from 'src/app/interfaces';
import { ErrorHandlerService } from '../error-handler.service';

@Injectable({
  providedIn: 'root',
})
export class TariffsService {
  private _apiUrl: string = environment.apiUrl;

  constructor(
    private http: HttpClient,
    private errorHandler: ErrorHandlerService,
  ) {}

  checkPayStatus(payLink: string): Observable<boolean> {
    return this.http
      .post<boolean>(`${this._apiUrl}/api/billing/check-progress-pay-link`, {
        payLink: payLink,
      })
      .pipe(
        catchError((err: any) => {
          this.errorHandler.handleError(err);
          return of(false);
        }),
      );
  }

  createProjectTokenPayLink(count: number, projectId: string): Observable<string> {
    return this.http
      .post(`${this._apiUrl}/api/project/payment/${projectId}/buyTokens`, { tokenCount: count })
      .pipe(
        map((res: any) => {
          if (res['link']) {
            return res.link;
          }

          return '';
        }),
      );
  }
}
